/* eslint react/no-unescaped-entities: 0 */
/* eslint react/display-name: 0 */
import React, { Component } from "react";
import ImportCompressorsContent from "./ImportCompressorsContent";

export default class extends Component {
  static propTypes = ImportCompressorsContent.propTypes;

  /**
   * {@inheritdoc}
   */
  render() {
    return (
      <div>
        <p>
          To import your compressors, the data must be saved in ODS or TSV format and 
          follow the structure below:
        </p>

        <ul>
          <li>Customer number</li>
          <li>Site no.</li>
          <li>Installation no.</li>
          <li>Marker</li>
          <li>Identifier number <i>(optional)</i></li>
          <li>Serial number <i>(optional)</i></li>
          <li>Type</li>
          <li>Classification</li>
          <li>Brand <i>(optional)</i></li>
        </ul>

        <p>{this.props.downloadSample}</p>

        <p>
          After the integration, a summary will inform you about the number of 
          created or updated entities, and an anomaly file will be available, 
          listing non-integrated rows and the reasons for rejection.
        </p>

        <p>Possible anomaly reasons include:</p>

        <ul>
          <li>Missing required data</li>
          <li>Non-existent type</li>
          <li>Non-existent classification</li>
          <li>Non-existent brand</li>
        </ul>
      </div>
    );
  }
}
